import { alpha, Theme } from '@mui/material';

export default {
    container: {
        flexShrink: 0,
        px: 2,
        borderBottom: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    closeBtn: {
        width: (theme: Theme) => theme.size.defaultHeight,
        height: (theme: Theme) => theme.size.defaultHeight,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'primary.main',

        '&:hover': {
            opacity: 0.85,
            cursor: 'pointer',
        },
    },
};
